import { render, staticRenderFns } from "./general-politic.vue?vue&type=template&id=55f93e52&scoped=true&"
import script from "./general-politic.vue?vue&type=script&lang=js&"
export * from "./general-politic.vue?vue&type=script&lang=js&"
import style0 from "./general-politic.vue?vue&type=style&index=0&id=55f93e52&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f93e52",
  null
  
)

export default component.exports